module.exports = __webpack_public_path__ + "img/adien-thomas.7b6c7d1b.png";